import { CheckinInterface } from '_/interfaces/CheckinInterface';
import { getDb } from './SqliteDatabase';

// Cria a tabela se não existir
const init = async () => {
  const db = getDb();
  await db.execAsync(`
    CREATE TABLE IF NOT EXISTS visits_table (
      id TEXT PRIMARY KEY,
      visit TEXT NOT NULL
    );
  `);
};

// Cria um novo registro na tabela
const create = async (obj: CheckinInterface) => {
  const db = getDb();
  const json = JSON.stringify(obj);

  await db.withTransactionAsync(async (txn) => {
    await txn.executeSqlAsync('INSERT INTO visits_table (id, visit) VALUES (?, ?);', [
      obj.visit.id,
      json,
    ]);
  });
};

// Remove um registro específico da tabela
const deleteOne = async (id: string) => {
  const db = getDb();

  await db.withTransactionAsync(async (txn) => {
    const result = await txn.executeSqlAsync('DELETE FROM visits_table WHERE id = ?;', [id]);

    if (result.rowsAffected === 0) {
      throw new Error(`Visit with id ${id} not found`);
    }
  });
};

// Retorna todos os registros
const all = async (): Promise<CheckinInterface[]> => {
  const db = getDb();
  const visits: CheckinInterface[] = [];

  await db.withTransactionAsync(async (txn) => {
    const { rows } = await txn.executeSqlAsync('SELECT * FROM visits_table;', []);
    for (let i = 0; i < rows.length; ++i) {
      visits.push(JSON.parse(rows.item(i).visit));
    }
  });

  return visits;
};

// Remove a tabela inteira
const deleteTable = async () => {
  const db = getDb();
  await db.execAsync('DROP TABLE IF EXISTS visits_table;');
};

export default {
  init,
  create,
  deleteOne,
  all,
  deleteTable,
};
